module Omni.Booker {
	export class GlobalBookerDetails {
		Country: string;
		City: string;
		Brand: string;
		Hotel: string;

		constructor() {
			this.Country = "-1";
			this.City = "-1";
			this.Brand = "-1";
			this.Hotel = "-1";
		}
	}

    class BookingDetail {
        BookingStartDate: string;
        BookingEndDate: string;
        RoomQuantity: string;
        Room1AdultQuantity: string;
        Room1ChildQuantity: string;
        Room1ChildAge1: string;
        Room1ChildAge2: string;
        Room1ChildAge3: string;
        Room1ChildAge4: string;
        Room2AdultQuantity: string;
        Room2ChildQuantity: string;
        Room2ChildAge1: string;
        Room2ChildAge2: string;
        Room2ChildAge3: string;
        Room2ChildAge4: string;
        Room3AdultQuantity: string;
        Room3ChildQuantity: string;
        Room3ChildAge1: string;
        Room3ChildAge2: string;
        Room3ChildAge3: string;
        Room3ChildAge4: string;
        AccountCode: string;
        GroupCode: string;
        AdaAccessible: string;
        HotelId: string;
        Rates: string;
        TravelAgentNumber: string;
        IsRedeemingFreeNights: boolean;
        VillasBedRoomQuantity: string;
        VillasView: string;

        constructor() {
            this.BookingStartDate = "";
            this.BookingEndDate = "";
            this.RoomQuantity = "";
            this.Room1AdultQuantity = "";
            this.Room1ChildQuantity = "";
            this.Room1ChildAge1 = "";
            this.Room1ChildAge2 = "";
            this.Room1ChildAge3 = "";
            this.Room1ChildAge4 = "";
            this.Room2AdultQuantity = "";
            this.Room2ChildQuantity = "";
            this.Room2ChildAge1 = "";
            this.Room2ChildAge2 = "";
            this.Room2ChildAge3 = "";
            this.Room2ChildAge4 = "";
            this.Room3AdultQuantity = "";
            this.Room3ChildQuantity = "";
            this.Room3ChildAge1 = "";
            this.Room3ChildAge2 = "";
            this.Room3ChildAge3 = "";
            this.Room3ChildAge4 = "";
            this.AccountCode = "";
            this.GroupCode = "";
            this.AdaAccessible = "";
            this.HotelId = "";
            this.Rates = "";
            this.TravelAgentNumber = "";
            this.IsRedeemingFreeNights = false;
            this.VillasBedRoomQuantity = "";
            this.VillasView = "";
        }
    }

    class BookingDetailGha {
        StartDate: string;
        EndDate: string;
        Country: string;
        City: string;
        HotelBrand: string;
        Hotel: string;

        constructor() {
            this.StartDate = "";
            this.EndDate = "";
            this.Country = "";
            this.City = "";
            this.HotelBrand = "";
            this.Hotel = "";
        }
    }

    export interface IBookingApiService {
        GetFindData(includeGha: boolean): ng.IPromise<any>;
        GetBookingLink(propertyDetail: PropertyDetail, travelDates: TravelDates, roomDetails: RoomDetail, rateCodes: RateCodes): ng.IPromise<string>;
        GetGhaLink(searchDetail: GlobalBookerDetails, travelDates: TravelDates): ng.IPromise<any>;
        GetGlobalData(country: string, city: string, brand: string, hotel: string): ng.IPromise<any>;
        GetExploreData(guid: string): ng.IPromise<any>;
    }

    class BookingApiService implements IBookingApiService {
        static $inject = [
            "$http",
            "$log",
            "$q",
            "moment"
        ];

        constructor(
            private readonly $http: ng.IHttpService,
            private readonly $log: ng.ILogService,
            private readonly $q: ng.IQService,
            private readonly moment
        ) {
        }

        GetBookingLink(propertyDetail: PropertyDetail,
            travelDates: TravelDates,
            roomDetails: RoomDetail,
            rateCodes: RateCodes): ng.IHttpPromise<string> {
            var model = this.generateBookingDetailModel(propertyDetail, travelDates, roomDetails, rateCodes);
            return this.$http.post("/find/bookings/checkratesandavailability", model).then((response) => {
                this.$log.debug("resolved checkrates=", response);
                return response.data;
            }).catch((response) => {
                this.$log.debug("failed checkrates=", response);
            });
        }

        GetGhaLink(searchDetail: GlobalBookerDetails, travelDates: TravelDates) {
            var model = this.generateGhaBookingDetailModel(searchDetail, travelDates);
            return this.$http.post("/find/bookings/checkgharatesandavailablity", model).then((response) => {
                this.$log.debug("resolved checkrates=", response);
                return response.data;
            }).catch((response) => {
                this.$log.debug("failed checkrates=", response);
            });
        }

        GetFindData(includeGha: boolean = false): ng.IHttpPromise<any> {
            return this.$http.get("/find/findandbook/autocomplete", { cache: true, params: { includeGha: includeGha } }).then((response: any) => {
                this.$log.debug("resolved autocomplete=", response);
                var mapped = response.data.map(function(currentValue) {
                    var newOne = new BookingDataResult();
                    newOne.category = currentValue.category;
                    newOne.City = currentValue.City;
                    newOne.label = currentValue.label;
                    newOne.State = currentValue.State;
                    newOne.ItemIdGuid = currentValue.ItemIdGuid;
                    newOne.ResultLabel = currentValue.ResultLabel;
                    newOne.SubCategory = currentValue.SubCategory;
                    newOne.IsComingSoonProperty = currentValue.IsComingSoonProperty;
                    newOne.ComingSoonText = currentValue.ComingSoonText;
                    newOne.HotelLink = currentValue.HotelLink;
                    newOne.RedeemFreeNights = currentValue.RedeemFreeNights;
                    newOne.HotelCode = currentValue.HotelCode;
                    newOne.IsVillas = currentValue.IsVillasProperty;
                    newOne.IsGha = currentValue.IsGha;
                    return newOne;
                });

                return mapped;
            }).catch((response) => {
                this.$log.debug("failed autocomplete=", response);
                return [];
            });
        }

        GetGlobalData(country: string, city: string, brand: string, hotel: string): ng.IHttpPromise<any> {
            var formatted = `${country}/${city}/${brand}/${hotel}`;

            return this.$http.get("/find/bookings/getgharesponsedata/" + formatted).then((response) => {
                this.$log.debug("resolved GHA=", response);
                return response.data;
            }).catch((response) => {
                this.$log.debug("failed GHA=", response);
                return response;
            });
        }

        GetExploreData(guid: string): ng.IHttpPromise<any> {
            return this.$http.get("/find/findandbook/getexploreoptions/" + guid, { cache: true })
                .then((response: any) => {
                    this.$log.debug("resolved exploreOptions=", response);
                    return response.data;
                }).catch((response) => {
                    this.$log.debug("failed exploreOptions=", response);
                    return [];
                });
        }

        private generateBookingDetailModel(propertyDetail: PropertyDetail,
            travelDates: TravelDates,
            roomDetails: RoomDetail,
            rateCodes: RateCodes): BookingDetail {
            var bookingDetailModel = new BookingDetail();
            bookingDetailModel.HotelId = propertyDetail.HotelId;

            // Travel dates
            if (travelDates.ArrivalDate) {
              // format to ISO 8601, this needs to be understood by .NET
              const formattedStart = this.moment.utc(travelDates.ArrivalDate).hour(0).minute(0).second(0).millisecond(0).format('MM-DD-YYYY');
              bookingDetailModel.BookingStartDate = formattedStart;

              if (travelDates.DepartureDate) {
                // format to ISO 8601, this needs to be understood by .NET
                const formattedEnd = this.moment.utc(travelDates.DepartureDate).hour(0).minute(0).second(0).millisecond(0).format('MM-DD-YYYY');
                bookingDetailModel.BookingEndDate = formattedEnd;
              }
            } else {
              // If we've cleared dates and have no start or end date, select the start date to today and nothing for end date.
              // format to ISO 8601, this needs to be understood by .NET
              const formattedStart = this.moment.utc().hour(0).minute(0).second(0).millisecond(0).format('MM-DD-YYYY');
              bookingDetailModel.BookingStartDate = formattedStart;
              bookingDetailModel.BookingEndDate = "";
            }
            // Rate codes
            bookingDetailModel.TravelAgentNumber = rateCodes.TravelAgentNumber;
            bookingDetailModel.AccountCode = rateCodes.PromoCode;
            bookingDetailModel.IsRedeemingFreeNights = rateCodes.IsRedeemingFreeNights;
            bookingDetailModel.GroupCode = rateCodes.GroupCode;
            bookingDetailModel.Rates = rateCodes.RateCode;

            // Room details
            bookingDetailModel.RoomQuantity = roomDetails.RoomCount.toString(10);
            bookingDetailModel.AdaAccessible = roomDetails.Accessible ? "true" : "false";
            //Villas Features
            if (propertyDetail.IsVillas) {
                bookingDetailModel.VillasBedRoomQuantity = roomDetails.BedRoomCount.Count.toString(10);
                bookingDetailModel.VillasView = roomDetails.VillasView.Value;
            }
            for (var i = 0; i < roomDetails.Rooms.length; i++) {
                var currentRoom = roomDetails.Rooms[i];
                switch (i) {
                case 0:
                    bookingDetailModel.Room1AdultQuantity = currentRoom.AdultCount.toString(10);
                    bookingDetailModel.Room1ChildQuantity = currentRoom.ChildCount.toString(10);
                    var childrenRm1 = mapChildren(currentRoom);
                    bookingDetailModel.Room1ChildAge1 = childrenRm1[0];
                    bookingDetailModel.Room1ChildAge2 = childrenRm1[1];
                    bookingDetailModel.Room1ChildAge3 = childrenRm1[2];
                    bookingDetailModel.Room1ChildAge4 = childrenRm1[3];
                    break;
                case 1:
                    bookingDetailModel.Room2AdultQuantity = currentRoom.AdultCount.toString(10);
                    bookingDetailModel.Room2ChildQuantity = currentRoom.ChildCount.toString(10);
                    var childrenRm2 = mapChildren(currentRoom);
                    bookingDetailModel.Room2ChildAge1 = childrenRm2[0];
                    bookingDetailModel.Room2ChildAge2 = childrenRm2[1];
                    bookingDetailModel.Room2ChildAge3 = childrenRm2[2];
                    bookingDetailModel.Room2ChildAge4 = childrenRm2[3];
                    break;
                case 2:
                    bookingDetailModel.Room3AdultQuantity = currentRoom.AdultCount.toString(10);
                    bookingDetailModel.Room3ChildQuantity = currentRoom.ChildCount.toString(10);
                    var childrenRm3 = mapChildren(currentRoom);
                    bookingDetailModel.Room3ChildAge1 = childrenRm3[0];
                    bookingDetailModel.Room3ChildAge2 = childrenRm3[1];
                    bookingDetailModel.Room3ChildAge3 = childrenRm3[2];
                    bookingDetailModel.Room3ChildAge4 = childrenRm3[3];
                    break;
                default:
                    break;
                }
            }

            function mapChildren(room: Room): string[] {
                var childrenMapped = [];

                for (var i = 0; i < 4; i++) {
                    var childAge = room.ChildAges[i] ? room.ChildAges[i].toString(10) : "";
                    childrenMapped.push(childAge);
                }

                return childrenMapped;
            }

            return bookingDetailModel;
        }

        private generateGhaBookingDetailModel(searchDetail: GlobalBookerDetails, travelDates: TravelDates):
            BookingDetailGha {
            const bookingDetail = new BookingDetailGha();

            bookingDetail.Country = searchDetail.Country;
            bookingDetail.City = searchDetail.City;
            bookingDetail.HotelBrand = searchDetail.Brand;
            bookingDetail.Hotel = searchDetail.Hotel;

            // format to ISO 8601, this needs to be understood by .NET
            const formattedStart = this.moment.utc(travelDates.ArrivalDate).hour(0).minute(0).second(0).millisecond(0).format('MM-DD-YYYY');
            const formattedEnd = this.moment.utc(travelDates.DepartureDate).hour(0).minute(0).second(0).millisecond(0).format('MM-DD-YYYY');

            bookingDetail.StartDate = formattedStart;
            bookingDetail.EndDate = formattedEnd;

            return bookingDetail;
        }
    }

    NgModule.service("omni.bookingapiservice", BookingApiService);
}
